import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import momentTZ from "moment-timezone";
import { DEFAULT_TIMEZONE } from "../../constants";
import AvailabilityCalendar from "../TrackAppointment/AvailabilityCalendar";
import { getPractitionerAvailability } from "../../services/practitioner";
import { collectColorKeysFromTimeslots } from "../../utils/locationColor";
import Loading from "../Shared/Loading";

import "./index.css";

const SpecialistProfileBox = ({ specialist, newOrReview }) => {
  const { id, avatarLink, firstName, lastName, specialities, language, qualification, profile } = specialist;
  const specialistSchedulerDescriptions = useSelector((state) => state.app.specialistSchedulerDescriptions);
  const schedule = _.get(specialistSchedulerDescriptions, [id, "value"], "");

  // Same clock as the availability the month drives - the tenant's, not the
  // browser's, or a coordinator near a month boundary browses the wrong month.
  const today = momentTZ().tz(DEFAULT_TIMEZONE);
  const [month, setMonth] = useState(today.format("MM"));
  const [year, setYear] = useState(today.format("YYYY"));
  const [selectedPractitionerAvailabilities, setSelectedPractitionerAvailabilities] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);

  const fetchPractitionerAvailabilities = useCallback(async () => {
    setIsFetchingData(true);
    const practitionerAvailabilities = await getPractitionerAvailability(id, `${year}${month}`, newOrReview);
    setSelectedPractitionerAvailabilities(practitionerAvailabilities);
    setIsFetchingData(false);
  }, [id, year, month, newOrReview]);

  useEffect(() => {
    if (!_.isEmpty(id)) {
      fetchPractitionerAvailabilities();
    }
  }, [id, fetchPractitionerAvailabilities]);

  return (
    <div className="box specialist-profile-container">
      {isFetchingData ? (
        <Loading />
      ) : (
        <article className="media">
          <div className="media-left">
            <figure className="image is-64x64">
              <img src={avatarLink} alt="avatar" />
            </figure>
          </div>
          <div className="media-content">
            <div className="content columns">
              <div className="column is-two-thirds">
                <strong>
                  {firstName} {lastName}
                </strong>{" "}
                <small>{specialities?.map((speciality) => speciality)}</small>
                <br />
                <small>{language}</small>
                <br />
                <small>{qualification}</small>
                <br />
                <div className="columns">
                  <div className={`column ${schedule ? "is-three-quarters" : ""}`}>{profile}</div>
                  {schedule && (
                    <div className="column profile-container">
                      <div className="has-text-weight-bold block">Schedule Description</div>
                      {schedule}
                    </div>
                  )}
                </div>
              </div>
              <div className="column">
                <AvailabilityCalendar
                  availableDates={selectedPractitionerAvailabilities
                    .filter(({ isValid }) => isValid)
                    .map(({ date, availableTimeslots }) => ({
                      date: date.replace(/-/g, ""),
                      selectedRooms: collectColorKeysFromTimeslots(availableTimeslots),
                    }))}
                  disableSelectTime={true}
                  month={month}
                  setMonth={setMonth}
                  year={year}
                  setYear={setYear}
                />
              </div>
            </div>
          </div>
        </article>
      )}
    </div>
  );
};
export default SpecialistProfileBox;
